import { dayBounds, DeliveryMatrixGroupBy, DeliveryWindow } from '../../../domain/entities/DeliveryDashboard';
import { DeliveryEventsQuery, IDeliveryDashboardRepository } from '../../ports/IDeliveryDashboardRepository';

export class LoadDeliveryOverviewUseCase {
  constructor(private repo: IDeliveryDashboardRepository) {}
  async execute(window: DeliveryWindow, groupBy: DeliveryMatrixGroupBy, timezone: string) {
    const [summary, alerts, matrix] = await Promise.all([
      this.repo.summary(window),
      this.repo.alerts(window),
      this.repo.matrix(window, groupBy, timezone),
    ]);
    return { summary, alerts, matrix };
  }
}

export class ListDeliveryEventsUseCase {
  constructor(private repo: IDeliveryDashboardRepository) {}
  execute(query: DeliveryEventsQuery) {
    const window = query.filters.day ? dayBounds(query.filters.day) : query.window;
    return this.repo.events({ ...query, window });
  }
}

export class GetDeliveryEventUseCase {
  constructor(private repo: IDeliveryDashboardRepository) {}
  execute(uuid: string) {
    return this.repo.event(uuid);
  }
}
